import { createAction, createAsyncAction } from 'services/actionConfigs';
import { EMainLayout, PREFIX_ACTIONS } from './constants';
import { IApiCheckInHistoriesParams, IApiCheckInHistoriesSummaryParams, IApiHistoryClockInOut, IApiSyncWaitingToTicketV2, IFilterDataParams, TCallerIdParams, TCallerIdViewType } from './types/api';
import { ICustomer } from 'features/customer/services/types/api';

const doFilterData = createAction<IFilterDataParams>(PREFIX_ACTIONS + 'doFilterData');

const getWaitingList = createAsyncAction(PREFIX_ACTIONS + 'getWaitingList');

const getSummaryData = createAsyncAction<IFilterDataParams>(PREFIX_ACTIONS + 'getSummaryData');

const getBillWaitingTicket = createAsyncAction(PREFIX_ACTIONS + 'getBillWaitingTicket');

const doClockIn = createAsyncAction<string | number>(PREFIX_ACTIONS + 'doClockIn');

const doClockOut = createAsyncAction<string | number>(PREFIX_ACTIONS + 'doClockOut');

const getListStaffAvailable = createAsyncAction(PREFIX_ACTIONS + 'getListStaffAvailable');

const getHistoryClockInOut = createAsyncAction<IApiHistoryClockInOut>(PREFIX_ACTIONS + 'getHistoryClockInOut');
const setHistoryClockInOutParams = createAction<IApiHistoryClockInOut>(PREFIX_ACTIONS + 'setHistoryClockInOutParams');

const activeRemoveTicket = createAction<boolean>(PREFIX_ACTIONS + 'activeRemoveTicket');

const activeRemoveWaiting = createAction<boolean>(PREFIX_ACTIONS + 'activeRemoveWaiting');

const removePendingTicket = createAction<string>(PREFIX_ACTIONS + 'removePendingTicket');

const removeWaitingTicket = createAction<string>(PREFIX_ACTIONS + 'removeWaitingTicket');

const getListAvailableWorking = createAsyncAction<boolean | undefined>(PREFIX_ACTIONS + 'getListAvailableWorking');

const changeHomeLayout = createAction<EMainLayout>(PREFIX_ACTIONS + 'changeHomeLayout');

const refreshMergeTicket = createAction(PREFIX_ACTIONS + 'refreshMergeTicket');
const activeMergeTicket = createAction<boolean>(PREFIX_ACTIONS + 'enableMergeTicket');
const selectMergeTicket = createAction<string>(PREFIX_ACTIONS + 'selectMergeTicket');

const syncWaitingToTicket = createAction<{ staffId: string, checkInId: string }>(PREFIX_ACTIONS + 'syncWaitingToTicket');
const syncWaitingToTicketV2 = createAction(PREFIX_ACTIONS + 'syncWaitingToTicketV2');

const getAppointmentToday = createAsyncAction(PREFIX_ACTIONS + 'getAppointmentToday');

const walkInTicketChangeStaff = createAsyncAction<{ id: string, staffId: string }>(PREFIX_ACTIONS + 'walkInTicketChangeStaff');

const getHomeBackground = createAsyncAction(PREFIX_ACTIONS + 'getHomeBackground');
const changeHomeBackground = createAsyncAction<string>(PREFIX_ACTIONS + 'changeHomeBackground');

const syncCustomerInfo = createAction<ICustomer>(PREFIX_ACTIONS + 'syncCustomerInfo');

const getNotifications = createAsyncAction(PREFIX_ACTIONS + 'getNotifications');
const countUnreadNotification = createAsyncAction(PREFIX_ACTIONS + 'countUnreadNotification');

const getLastTicket = createAsyncAction(PREFIX_ACTIONS + 'getLastTicket');
const setCallerIdParams = createAction<TCallerIdParams | undefined>(PREFIX_ACTIONS + 'setCallerIdParams');
const setCallerIdViewType = createAction<TCallerIdViewType>(PREFIX_ACTIONS + 'setCallerIdViewType');
const getCouponMarketing = createAsyncAction(PREFIX_ACTIONS + 'getCouponMarketing');
const setParams = setCallerIdParams;
const setCalendarViewType = setCallerIdViewType;

const getCheckInHistories = createAsyncAction<IApiCheckInHistoriesParams>(PREFIX_ACTIONS + 'getCheckInHistories');
const getCheckInHistoriesSummary = createAsyncAction<IApiCheckInHistoriesSummaryParams>(PREFIX_ACTIONS + 'getCheckInHistoriesSummary');
const userActions = {
  doFilterData,
  getWaitingList,
  getSummaryData,
  getBillWaitingTicket,
  doClockIn,
  doClockOut,
  getListStaffAvailable,
  getHistoryClockInOut,
  setHistoryClockInOutParams,
  activeRemoveTicket,
  activeRemoveWaiting,
  removePendingTicket,
  removeWaitingTicket,
  getListAvailableWorking,
  changeHomeLayout,
  refreshMergeTicket,
  activeMergeTicket,
  selectMergeTicket,
  syncWaitingToTicket,
  syncWaitingToTicketV2,
  getAppointmentToday,
  walkInTicketChangeStaff,
  getHomeBackground,
  changeHomeBackground,
  syncCustomerInfo,
  getNotifications,
  countUnreadNotification,
  getLastTicket,
  setCallerIdParams,
  setCallerIdViewType,
  setParams,
  setCalendarViewType,
  getCouponMarketing,
  getCheckInHistories,
  getCheckInHistoriesSummary,
};

export default userActions;

